/**
 * Copyright (c) 2026 Constructor Technology AG. All rights reserved.
 *
 * Proprietary and confidential. Unauthorized copying, distribution, or use
 * is prohibited.
 *
 * SPDX-License-Identifier: LicenseRef-Constructor-Proprietary
 */

import * as types from './mutation-types';

const MAX_COUNT = 5

export const add = ({ commit, state }, payload) => {
  const item = {
    ...payload,
    id: `notification${Date.now()}`,
  };
  const curItems = state.items
  const newItems = curItems.length >= MAX_COUNT
    ? [...curItems.slice(curItems.length - (MAX_COUNT - 1)), item]
    : [...state.items, item]
  commit(types.ADD, newItems);
}

export const actionNotAssigned = ({ dispatch }) => {
  dispatch('warning', 'The action has not been assigned yet.')
};

export const error = ({ dispatch }, message) => {
  dispatch('add', { type: 'error', message })
};

export const remove = ({ commit, getters }, payload) => {
  const items = getters.items.filter(({ id }) => id !== payload)
  commit(types.REMOVE, items)
};

export const success = ({ dispatch }, message) => {
  dispatch('add', { type: 'success', message })
};

export const warning = ({ dispatch }, message) => {
  dispatch('add', { type: 'warning', message })
};

export default {
  add,
  actionNotAssigned,
  success,
  error,
  warning,
  remove,
};
